import Landing from './landing/components';
import Marketing from './landing/components/MarketingContainer';
import Subscription from './subscription/components';
import Highlights from './products/Products';
import Products from './core/components/product/Products';

export default {
  subscription: Subscription,
  'highlights-subscription': Products,
  highlights: Highlights,
  'highlights-v2': Products,
  vertical: Landing,
  marketing: Marketing,
};
